<template>
  <svg width="60"
       height="11"
       viewBox="0 0 60 11"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <rect width="60"
          height="11"
          fill="#009CD4" />
  </svg>
</template>
